/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ProtectedMicrosoft365ObjectsStore } from '../stores/ProtectedMicrosoft365ObjectsStore';

export const ProtectedMicrosoft365ObjectsContext = createContext<ProtectedMicrosoft365ObjectsStore>({} as ProtectedMicrosoft365ObjectsStore);
